/**
 * Get revenue value
 * @param {{subTotal: string, discount: string}} - Prices
 * @returns {number} Revenue
 */
export function getRevenueValue(
    {
        discount,
        subTotal,
    }: {
        subTotal: number | string;
        discount: number | string;
    } = {discount: 0, subTotal: 0},
): number {
    if (Number(subTotal) < Number(discount)) return 0;
    return Number(subTotal) - Number(discount);
}
